import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import DocReadPanel from './DocReadPanel';

// L8 — カードの ⋯ からも読み直せるようにする（ビューアーを開かなくてよい）
export default function DocReadDialog({ open, documentId, title, canEdit, onClose, onChanged }) {
  if (!open) return null;
  return (
    <Dialog open onOpenChange={(o) => { if (!o) onClose?.(); }}>
      <DialogContent className="max-w-lg" data-testid="dms-read-dialog">
        <DialogHeader>
          <DialogTitle className="text-base">読み直し・読み取り内容の修正</DialogTitle>
          <DialogDescription className="text-xs">
            読み取った本文・図番・責任者・検索キーワードの確認と修正、読み直しができます。
          </DialogDescription>
        </DialogHeader>
        <p className="text-xs text-zinc-500 truncate" title={title}>{title}</p>
        <div className="max-h-[70vh] overflow-y-auto pr-1">
          <DocReadPanel documentId={documentId} canEdit={canEdit} onChanged={onChanged} />
        </div>
      </DialogContent>
    </Dialog>
  );
}
